import * as ACTION_TYPES from '../actions/action_type';

const initialState = {
    profile: null,
    loading: false,
    errors: {err: {}, msg: []},
};

const profileReducer = (state = initialState, action) => {
    switch (action.type) {
        case "FETCH_PROFILE_START":
            return {...state, loading: true, error: null};
        case "FETCH_PROFILE_SUCCESS":
            return { ...state, profile: action.payload, loading: false };
        default:
            return state;
    }
}

export default profileReducer;
